import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";

const EmailPreferencesComponent = () => {
  const [agreements, setAgreements] = useState(false);
  const [postedJobs, setPostedJobs] = useState(false);
  const [messages, setMessages] = useState(false);
  const [supportHours, setSupportHours] = useState(false);
  const [jobAlerts, setJobAlerts] = useState([
    "Mary poppins.....Getting jobs done while having fun",
    "Provide social support and help with light housework",
    "Help a 90 year old woman with an outing for a manicure, pedicure and transport to and from the shops",
  ]);

  const removeJobAlert = (job) => {
    setJobAlerts((prevAlerts) => prevAlerts.filter((alert) => alert !== job));
  };

  return (
    <div className="email-preferences-settings">
      <h3>Subscribe to Email Alerts</h3>
      <div className="emlprfrncsttngs-checkbox-section">
        <label className="emlprfrncsttngs-checkbox-label">
          <input
            type="checkbox"
            className="emlprfrncsttngs-checkbox"
            checked={agreements}
            onChange={() => setAgreements(!agreements)}
          />
          I would like to receive emails about agreements
        </label>

        <label className="emlprfrncsttngs-checkbox-label">
          <input
            type="checkbox"
            className="emlprfrncsttngs-checkbox"
            checked={postedJobs}
            onChange={() => setPostedJobs(!postedJobs)}
          />
          I would like to receive emails about posted jobs
        </label>

        <label className="emlprfrncsttngs-checkbox-label">
          <input
            type="checkbox"
            className="emlprfrncsttngs-checkbox"
            checked={messages}
            onChange={() => setMessages(!messages)}
          />
          I would like to receive emails about messages
        </label>

        <label className="emlprfrncsttngs-checkbox-label">
          <input
            type="checkbox"
            className="emlprfrncsttngs-checkbox"
            checked={supportHours}
            onChange={() => setSupportHours(!supportHours)}
          />
          I would like to receive emails about support hours
        </label>
      </div>

      <p className="emlprfrncsttngs-note">
        <FaInfoCircle className="emlprfrncsttngs-note-icon" />
        Please note, you will still receive system notifications for
        interactions on the One Support Hub platform.
      </p>

      <button className="email-preferences-save-button">Save</button>

      <div className="email-preferences-alerts-container">
        <h3>Customised job alerts</h3>
        <div className="email-custom-job-alerts">
          <ul className="emlprfrncsttngs-job-list">
            {jobAlerts.map((job, index) => (
              <li key={index} className="emlprfrncsttngs-job-item">
                {job}{" "}
                <button
                  onClick={() => removeJobAlert(job)}
                  className="emlprfrncsttngs-remove-button"
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EmailPreferencesComponent;
